// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are redirected to the login page.
import React, { useEffect } from 'react'
import { Redirect, Route } from 'react-router-dom'
import Cookie from '../../services/CookieService';
import jwt_decode from 'jwt-decode';
//Redux
import { closeSession } from '../../services/AuthService';
import { useDispatch } from 'react-redux';
import { setObjectAction } from '../../actions/authActions';
//Función principal
const PrivateRoute = ({ component: Component, ...rest }) => {    
    //Tomo el objeto
    const { object } = rest;    
    //Inicializo el dispatch
    const dispatch = useDispatch();    
    //Busco la cookie
    const token = Cookie.get(process.env.REACT_APP_COOKIE_NAME);
    const TOKEN_EXPIRATION_MARGIN = 30 * 1000;    
    // Verifico que el token exista y no esté vencido
    let validToken = false;
    if (token) {
        try {
            const decoded = jwt_decode(token);
            validToken = !!decoded.exp && decoded.exp * 1000 > Date.now() + TOKEN_EXPIRATION_MARGIN;
        } catch (error) {
            validToken = false;
        }
    }    
    //Seteo el objeto
    dispatch( setObjectAction(object) );    
    // Elimino la sesión fuera del render si el token existe pero no es válido
    useEffect(() => {
        if (token && !validToken) {
            closeSession();
        }
    }, [token, validToken]);    
    //Renderizo
    return (
        <Route
            {...rest}
            render={props => validToken ? (
                <Component {...props} object={object} />
            ) : (
                <Redirect to={{
                    pathname: "/iniciar-sesion",
                    state: { from: props.location }
                }} />
            )}
        />
    )
}
            
            export default PrivateRoute